export function getLingue(): SelectItem<string>[] {
  return [
    { id: 'it', descrizione: 'Italiano' },
    { id: 'en', descrizione: 'English' },
  ];
}
